import React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { ThemeConsumer } from './ThemeContext';
export function withTheme(WrappedComponent) {
    const ThemedComponent = React.forwardRef((props, forwardedRef) => (<ThemeConsumer>
      {theme => (<WrappedComponent {...props} ref={forwardedRef} theme={theme}/>)}
    </ThemeConsumer>));
    return hoistStatics(ThemedComponent, WrappedComponent);
}
